var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTelegram({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9544 6.1832L17.5399 17.2153C17.3576 17.9938 16.8826 18.1876 16.2077 17.821L12.5285 15.1944L10.7534 16.8488C10.5568 17.0392 10.3928 17.1981 10.0139 17.1981L10.2785 13.5682L17.097 7.59896C17.3936 7.34316 17.0324 7.20086 16.6363 7.45722L8.20687 12.5998L4.57791 11.4991C3.78868 11.2604 3.7744 10.7345 4.7425 10.3674L18.9366 5.06919C19.5938 4.83055 20.1687 5.21038 19.9544 6.1832Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/Telegram.a145d3f2.svg";
export { ForwardRef as ReactComponent };